import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';

import { DEQ_COMPS, DEQ_TYPES } from '../../../utils/deq';

import mq from '../../../styles/breakpoints';
import colors from '../../../styles/colors';
import { Body } from '../../../styles/generic';
import Spacings from '../../../styles/Spacings';

interface FooterLink {
  label: string;
  url: string;
}

interface FooterProps {
  footer: {
    externalLinks: FooterLink[];
    footerTitle: string;
  };
}

const Footer = () => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      allFooterJson {
        edges {
          node {
            footer {
              externalLinks {
                label
                url
              }
              footerTitle
            }
          }
        }
      }
    }
  `);

  const footerStaticContent = (data.allFooterJson.edges[0].node as FooterProps)
    .footer;

  return (
    <FooterContainer>
      <SubFooter>
        <ExternalLinks>
          {footerStaticContent.externalLinks.map((link: FooterLink) => (
            <ExternalLink
              key={link.label}
              href={link.url}
              target="_blank"
              data-component-type={DEQ_COMPS.footer}
              data-element-type={DEQ_TYPES.textLink}
              data-element-label={`${link.label}`.toLowerCase()}
              data-element-target={link.url}
            >
              {link.label}
            </ExternalLink>
          ))}
        </ExternalLinks>
        <CopyRight>{footerStaticContent.footerTitle}</CopyRight>
      </SubFooter>
    </FooterContainer>
  );
};

export default Footer;

const FooterContainer = styled.footer`
  align-self: flex-end;
  flex-grow: 1;
  height: fit-content;
  width: 100%;
`;

const SubFooter = styled(Body)`
  background-color: ${colors.white};
  box-sizing: border-box;
  padding: ${Spacings.L};
  width: 100%;

  ${mq.from.breakpoint.M`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `}
`;

const ExternalLink = styled.a`
  color: ${({ theme }) => theme.colors.abnGreen300};
  line-height: 24px;
  margin-right: ${Spacings.XS};
  text-decoration: none;
  transition: color 0.1s ease-in-out;

  &:hover {
    color: ${({ theme }) => theme.colors.abnGreen400};
  }
  &:after {
    content: '|';
    margin-left: ${Spacings.XS};
  }
`;

const ExternalLinks = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.colors.abnGreen300};
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  ${ExternalLink} {
    &:last-of-type {
      &:after {
        display: none;
      }
    }
  }
`;

const CopyRight = styled.span`
  color: ${colors.black};

  ${mq.to.breakpoint.M`
    margin-top: ${Spacings.S};
    text-align: center;
    display: block;
  `}
`;
